import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  hideNavFooter?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({ children, fullWidth = false, hideNavFooter = false }) => {
  const paddingClass = fullWidth ? 'py-6 px-3 sm:px-4 lg:px-6' : 'py-6 px-4 sm:px-6 lg:px-8';
  const wrapperClass = fullWidth ? 'w-full mx-auto' : 'w-full max-w-7xl mx-auto';

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col transition-colors duration-200">
      {!hideNavFooter && <Navbar />}
      <main className={`flex-1 w-full ${paddingClass}`}>
        <div className={wrapperClass}>
          {children}
        </div>
      </main>
      {!hideNavFooter && <Footer />}
    </div>
  );
};
